<template>
  <v-container fluid fill-height pa-0 ma-0 class="test_green">
    <v-toolbar app>
      <v-btn icon @click="$router.push({ name: 'Checkout' })">
        <v-icon v-text="'mdi-arrow-left'" />
      </v-btn>
      <v-toolbar-title>Back to checkout page</v-toolbar-title>
      <v-spacer></v-spacer>
      <Language />
      <div v-if="$store.getters.checkAuth" class="px-2">
        <ProfileCustomer />
      </div>
    </v-toolbar>
    <v-row
      class="d-flex justify-center align-center"
      style="height: calc(100vh - 64px)"
    >
      <ReepayComponent
        v-if="flatPayCheckoutData.fp_id"
        :session-id="flatPayCheckoutData.fp_id"
        :on-success="handleSuccess"
        :on-failure="handleFailure"
      />
    </v-row>
  </v-container>
</template>

<script>
import ReepayComponent from "@/views/front/checkout/components/ReepayComponent.vue";
import orderMixin from "@/mixins/orderMixin";

export default {
  layout: "Public",
  middleware: "sessionCart",
  name: "FlatPayPayment",
  components: {
    ReepayComponent,
  },
  mixins: [orderMixin],
  data: () => ({
    reepay: null,
    flatPayCheckoutData: null,
  }),
  beforeMount() {
    this.flatPayCheckoutData = this.$store.getters.flatPayCheckoutData;
  },

  methods: {
    handleSuccess(data) {
      console.log("Payment was successful!", data);
      if (this.$store.getters.isNewFlatPayMethod) {
        const checkoutData =
          this.$store.getters.flatPayCheckoutData.checkoutData;
        checkoutData.paymentProviderPaymentId = data.payment_method;
        checkoutData.paymentProviderCustomerId = data.customer;
        this.handlerCompleteOrder(checkoutData, data.invoice);
      } else {
        this.handlerCompleteOrder(
          this.$store.getters.flatPayCheckoutData.checkoutData,
          data.invoice
        );
      }
      // Additional success handling
    },
    handleFailure(data) {
      console.log("Payment failed!", data);
      // Additional failure handling
    },
  },
};
</script>

<style lang="scss" scoped>
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

.header {
  height: 90px;
  width: 100%;
}
</style>
